import { UserType } from './general';

export interface EmailMapping {
  emailId: string;
  emailAddress: string;
  enrollmentPeriodId: string;
  status: Status;
  userType: UserType;
}

export enum Status {
  BOUNCED = 'BOUNCED',
  SENT = 'SENT',
  OPENED = 'OPENED',
  FAILED_TO_SEND = 'FAILED_TO_SEND',
  BLOCK = 'BLOCK',
  INVALID = 'INVALID',
  SPAM = 'SPAM',
  NEW = 'NEW', //  New status is only on FE
}

export interface Email {
  id: string;
  domainId: string;
  emailType: string;
  status: GeneralStatus;
  creationDateTime: string;
  userTypes: string[];
  emailAddress: string;
  reason: string;
}

export interface SendGridContext {
  templateId: string;
  templateData: Record<string, string>;
  toEmailAddresses: string[];
  from: string;
}

export enum GeneralStatus {
  BOUNCED = 'BOUNCED',
  SENT = 'SENT',
  OPENED = 'OPENED',
  FAILED_TO_SEND = 'FAILED_TO_SEND',
  BLOCK = 'BLOCK',
  INVALID = 'INVALID',
  SPAM = 'SPAM',
}

export interface ConfigurableEmailInfo {
  title: string;
  description: string;
  name: string;
}

export interface ConfigurableEmails {
  emails: ConfigurableEmailInfo[];
  emailsForUser: string[];
}
